import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import ExpiredLink from "./ExpiredLink/container";
import Login from "./Login/container";
import ResetPassword from "./ResetPassword/container";
import SendResetLink from "./SendResetLink/container";
import { type LoginForm } from "./types";

import "./style.less";

export type MapProps = RootContainerProps & {
  heading: string;
  hint: string;
  linkInfo: LoginForm.View.LinkInfo | null;
  mode: LoginForm.Mode;
};

export type ActionProps = {
  setMode: (mode: LoginForm.Mode) => void;
};

type Props = ActionProps & MapProps;
export default (props: Props) => (
  <Container className="wsc_content_login_form" {...getContainerProps(props)}>
    {!!props.heading && <h3>{props.heading}</h3>}
    {!!props.hint && <p>{props.hint}</p>}

    {props.mode === "login" ? (
      <Login {...getRootContainerProps(props)} />
    ) : props.mode === "sendResetLink" ? (
      <SendResetLink {...getRootContainerProps(props)} />
    ) : props.mode === "resetPassword" ? (
      <ResetPassword {...getRootContainerProps(props)} />
    ) : props.mode === "expiredLink" ? (
      <ExpiredLink {...getRootContainerProps(props)} />
    ) : null}

    {!!props.linkInfo && (
      <div className="link_wrap">
        <a onClick={() => props.setMode(props.linkInfo!.goTo)}>{props.linkInfo.caption}</a>
      </div>
    )}
  </Container>
);
